function hasMsalAuthorizationResponse(hash) {
  const responseParameters = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return responseParameters.has('state')
    && (responseParameters.has('code') || responseParameters.has('error'));
}

/** Return whether this window is the passive callback for an MSAL login popup. */
export function isMsalPopupCallback(browserWindow) {
  return browserWindow.location.pathname === '/'
    && Boolean(browserWindow.opener)
    && hasMsalAuthorizationResponse(browserWindow.location.hash);
}
